import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useSaveServiceParams } from 'shared/lib';

import {
  AuthError,
  Main,
  Pact,
  PtInfoCheck,
  ServiceCancel,
  ServiceCancelSuccess,
  SpecimenDetail,
  Specimens,
} from './ui';

export const KareNote = () => {
  useSaveServiceParams('kareNote');

  return (
    <Routes>
      <Route
        path='/'
        element={
          <Suspense>
            <Main />
          </Suspense>
        }
      />
      <Route
        path='/pact'
        element={
          <Suspense>
            <Pact />
          </Suspense>
        }
      />
      <Route
        path='/service-cancel'
        element={
          <Suspense>
            <ServiceCancel />
          </Suspense>
        }
      />
      <Route
        path='/service-cancel-success'
        element={
          <Suspense>
            <ServiceCancelSuccess />
          </Suspense>
        }
      />
      <Route
        path='/Specimens'
        element={
          <Suspense>
            <Specimens />
          </Suspense>
        }
      />
      <Route
        path='/specimens/:specimenCode'
        element={
          <Suspense>
            <SpecimenDetail />
          </Suspense>
        }
      />
      <Route
        path='/auth-error'
        element={
          <Suspense>
            <AuthError />
          </Suspense>
        }
      />
      <Route
        path='/pt-info-check'
        element={
          <Suspense>
            <PtInfoCheck />
          </Suspense>
        }
      />
    </Routes>
  );
};

